import { apiRequest } from "../helpers/helpers"

export const getDocumentImage = async (requestId: string, type: string) => {
    const response = await apiRequest(`${process.env.REACT_APP_API_URL}/api/v1/admin/doc-image`,
        'POST',
        {
            requestId,
            type
        }
    )

    return response
}